import * as React from 'react';

import * as Styled from './bottom-sheet.styles';
import type { BottomSheetProps } from './bottom-sheet.types';

export const BottomSheetPrimitive = React.forwardRef<
  HTMLDivElement,
  BottomSheetProps & { closeModal: (event?: React.SyntheticEvent) => void }
>(
  (
    { children, className, closeModal, show, showCloseButton, ...props },
    forwardedRef
  ) => (
    <Styled.BottomSheet
      aria-modal="true"
      className={className}
      data-show={show}
      data-xds="BottomSheet"
      ref={forwardedRef}
      role="dialog"
      {...props}
    >
      <Styled.Wrapper>
        {children}
        {showCloseButton ? (
          <Styled.Close size="large" onClick={closeModal} />
        ) : null}
      </Styled.Wrapper>
    </Styled.BottomSheet>
  )
);

BottomSheetPrimitive.displayName = 'BottomSheet (Primitive)';
